export const REPAYMENT_DESCRIPTION_OPTIONS = [
  'Refund',
  'Adjustment',
  'Daily Repayment',
  'Monthly Repayment',
  'Monthly Refund',
  'Monthly Adjustment',
  'Debt Sale',
  'Debt Sale Adjustment',
] as const

export const REPAYMENT_DATA_SOURCE_OPTIONS = [
  'CardOne', 'FDMS', 'First Data', 'APS', 'Gocardless', 'Cardnet', 'Lloyds',
  'TrueLayer', 'Other', 'Legal', 'Processor Fees', 'Refund',
  'Direct Payment', 'Write Off', 'Write Off Recovery', 'Modulr', 'Revolut',
  'Competitor', 'Legal Fees Recovered', 'Balance Transfer',
  'Legal Fees Added', 'Dojo (Direct Split)',
  'Owed to Debt Purchaser',
] as const
